import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretRight = () => {
  return (
    <g>
      <path d="m4.55 14.2562c0 .605.35.75.7778.3222l5.8006-5.8006a1.1032 1.1032 0 0 0 0-1.5556l-5.8002-5.8006c-.4282-.4278-.7782-.2828-.7782.3222z" />
    </g>
  );
};

export default withIcon(IconCaretRight);
